// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"488":"e1c72cd3","764":"d71af9d8"}[chunkId] + ".chunk.css");